export function GetData(customerNo,zipCode) {
    try {
        
        console.log("GetData CustomerNo: " + customerNo + " zipCode: " + zipCode);

        let endpoint = 'https://skyshowtime.sappa.se/api/activation?customerNo='+ customerNo + '&zipCode=' + zipCode;

        fetch(endpoint,{method: 'POST',headers:{Authorization: '14CB411572204EA39CA067D3A0CCF816'}})
        .then(response =>{
            
            return response.json();
        } )
        .then(data => {
            
            return data;
            
        })
        .catch(
            exp =>{
            return null;
            console.log(exp);
            }
            );



    } catch (error) {
        console.log(error);
       return null;
    }
}

